export const status = [
  { id: 'sent', name: 'SENT' },
  { id: 'failed', name: 'FAILED' },
];
